export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/noop.js
// module id = ./node_modules/d3-geo/src/noop.js
// module chunks = 53